// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Antd from 'ant-design-vue';
import App from './App';
import router from './router';
import Storage from 'vue-ls';
import fastClick from 'fastclick';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import store from './store';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import 'ant-design-vue/dist/antd.css';
import '../node_modules/bootstrap/dist/js/bootstrap.js';
import 'styles/reset.css';
import 'styles/border.css';
import 'styles/iconfont.css';
import common from './common/js/common.js'; // 引入公共函数库
import vueBus from '@/utils/vueBus'; // 引入vuebus用于组件通讯
Vue.use(vueBus);

Vue.use(Storage, {
  namespace: 'pro__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
});

import vueEsign from 'vue-esign';
Vue.use(vueEsign);

import JDictSelectTag from './components/dict/index.js';
import JMultiSelectTag from './components/dict/multIndex.js';
Vue.use(JDictSelectTag);
Vue.use(JMultiSelectTag);

Vue.config.productionTip = false;
Vue.prototype.common = common;

fastClick.attach(document.body);
Vue.use(VueAwesomeSwiper);
Vue.use(VueAxios, axios);
Vue.use(Antd);

// axios配置接口路径
axios.defaults.baseURL = process.env.baseURL;
//axios.defaults.baseURL = "http://192.168.111.29:9002";
// axios.defaults.baseURL = "https://test-stu8.jxjypt.cn";
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    const token = common.getToken();
    config.headers['X-Access-Token'] = token || 'xx';
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
  if (response.config.responseType === 'blob') {
    return response.data;
  }
  // 对响应数据做点什么
  if (response.data.code === 200 || response.data.code === 0 || response.data.code === 511) {
    return response.data;
  } else if (response.data.code === 401) {
    if (response.data.result.path === '/biz/home/mustDeal/check') {
      return;
    }
    localStorage.removeItem('token');
    if (localStorage.getItem('isLoginByInter') === '1' && localStorage.getItem('redirectUrl')) {
      location.href = localStorage.getItem('redirectUrl');
      return;
    }
    vue.$message.destroy();
    vue.$message.error('验证失败，请重新登录', 3);

    setTimeout(() => {
      common.toURL('/login');
    }, 1000);
    return Promise.reject(response);
  } else if (response.data.code === 510 && response.data.message === '请重新登录') {
    // 510 = SC_NO_AUTHZ（学生端 reLogin 返回），会话失效统一引导重新登录；
    // 同 code 的“未绑定”等其它语义不在此处理，走通用提示分支
    localStorage.removeItem('token');
    if (localStorage.getItem('isLoginByInter') === '1' && localStorage.getItem('redirectUrl')) {
      location.href = localStorage.getItem('redirectUrl');
      return;
    }
    vue.$message.destroy();
    vue.$message.error('登录已失效，请重新登录', 3);
    setTimeout(() => {
      common.toURL('/login');
    }, 1000);
    return Promise.reject(response);
  } else if (response.data.code === 404) {
    vue.$message.error('请求服务器失败！404', 3);
    return Promise.reject(new Error('error'));
  } else if (response.data.code !== 500) {
    common.judgeAlertOrMessage(response.data.message);
    return Promise.reject(response);
  } else {
    common.judgeAlertOrMessage(response.data.message);
    return Promise.reject(response);
  }
});

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});

export default vue;



// WEBPACK FOOTER //
// ./src/main.js